export default __webpack_public_path__ + "static/media/active-chk.18bc3abc.svg";